import React, { useState, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSidebarMenu } from '@app/store/reducers/ui';
import { logoutUser } from '@store/reducers/auth';

import DashboardPage from '@app/pages/DashboardPage';
import SystemInfoPage from '@app/pages/SystemInfoPage';
import OnuStatusPage from '@pages/OnuStatusPage';
import OnuStatusConfigPage from '@app/pages/OnuStatusConfigPage';
import OnuPonInfoPage from '@app/pages/OnuPonInfoPage';
import OltStatusPage from '@app/pages/OltStatusPage';
import OltStatusConfigPage from '@app/pages/OltStatusConfigPage';
import OltPonInfoPage from '@app/pages/OltPonInfoPage';
import OltAlarmsPage from '@app/pages/OltAlarmsPage';
import LanAddressPage from '@app/pages/LanAddressPage';
import SNMPAgentPage from '@app/pages/SNMPAgentPage';
import NTPClientPage from '@app/pages/NTPClientPage';
import PasswordPage from '@app/pages/PasswordPage';
import BackupRestorePage from '@app/pages/BackupRestorePage';
import FactoryResetPage from '@app/pages/FactoryResetPage';
import FirmwareUpgradePage from '@app/pages/FirmwareUpgradePage';
import RebootPage from '@app/pages/RebootPage';

import Header from './header/Header';
import Footer from './footer/Footer';
import MenuSidebar from './menu-sidebar/MenuSidebar';
import PageLoading from '../../components/page-loading/PageLoading';
import axios from '@utils/axios'


const Main = () => {
  const dispatch = useDispatch();
  const isSidebarMenuCollapsed = useSelector(
    (state) => state.ui.isSidebarMenuCollapsed
  );
  const screenSize = useSelector((state) => state.ui.screenSize);
  const [appLoadingState, updateAppLoading] = useState(true);

  const handleToggleMenuSidebar = () => {
    dispatch(toggleSidebarMenu());
  };

  useEffect(() => {
    updateAppLoading(true);

    document.getElementById('root').classList.remove('register-page');
    document.getElementById('root').classList.remove('login-page');
    document.getElementById('root').classList.remove('hold-transition');

    document.getElementById('root').classList.add('sidebar-mini');
    document.getElementById('root').classList.add('layout-fixed');
    let mounted = true
    setTimeout(() => {
      if( mounted ){
        updateAppLoading(false)
    }}, 1000);
    return () => {
      document.getElementById('root').classList.remove('sidebar-mini');
      document.getElementById('root').classList.remove('layout-fixed');
      mounted = false
    };
  }, []);

  useEffect(() => {
    document.getElementById('root').classList.remove('sidebar-closed');
    document.getElementById('root').classList.remove('sidebar-collapse');
    document.getElementById('root').classList.remove('sidebar-open');
    if (isSidebarMenuCollapsed && screenSize === 'lg') {
      document.getElementById('root').classList.add('sidebar-collapse');
    } else if (isSidebarMenuCollapsed && screenSize === 'xs') {
      document.getElementById('root').classList.add('sidebar-open');
    } else if (!isSidebarMenuCollapsed && screenSize !== 'lg') {
      document.getElementById('root').classList.add('sidebar-closed');
      document.getElementById('root').classList.add('sidebar-collapse');
    }
  }, [screenSize, isSidebarMenuCollapsed]);

  const Logout = () => {
    axios.get('/api/user/logout')
      .then((res) => {
        dispatch(logoutUser());
      })
      .catch((e) => { })
    return (
      <Redirect to='/login' />
    );
  }

  let template;

  if (appLoadingState) {
    template = <PageLoading />;
  } else {
    template = (
      <>
        <Header toggleMenuSidebar={handleToggleMenuSidebar} />

        <MenuSidebar />

        <div className="content-wrapper">
          <div className="pt-3" />
          <section className="content">
            <Switch>
              <Route exact path="/" component={DashboardPage} />
              <Route exact path="/system-info" component={SystemInfoPage} />
              <Route exact path="/onu/status/config/:id" component={OnuStatusConfigPage} />
              <Route exact path="/onu/status/:filter?" component={OnuStatusPage} />
              <Route exact path="/onu/info/:filter?" component={OnuPonInfoPage} />
              <Route exact path="/olt/status/config/:id" component={OltStatusConfigPage} />
              <Route exact path="/olt/status" component={OltStatusPage} />
              <Route exact path="/olt/info" component={OltPonInfoPage} />
              <Route exact path="/olt/alarms" component={OltAlarmsPage} />
              <Route exact path="/management-card/lan-address" component={LanAddressPage} />
              <Route exact path="/management-card/snmp-agent" component={SNMPAgentPage} />
              <Route exact path="/management-card/ntp-client" component={NTPClientPage} />
              <Route exact path="/management-card/password" component={PasswordPage} />
              <Route exact path="/management-card/backup-restore" component={BackupRestorePage} />
              <Route exact path="/management-card/factory-reset" component={FactoryResetPage} />
              <Route exact path="/management-card/firmware-upgrade" component={FirmwareUpgradePage} />
              <Route exact path="/management-card/reboot" component={RebootPage} />
              <Route exact path="/logout" component={Logout} />
            </Switch>
          </section>
        </div>
        <Footer />
        <div
          id="sidebar-overlay"
          role="presentation"
          onClick={handleToggleMenuSidebar}
          onKeyDown={() => { }}
        />
      </>
    );
  }

  return <div className="wrapper">{template}</div>;
};

export default Main;
